import { render, staticRenderFns } from "./AppMenuBarraSuperior.vue?vue&type=template&id=44b3ad84&"
import script from "./AppMenuBarraSuperior.vue?vue&type=script&lang=js&"
export * from "./AppMenuBarraSuperior.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuBarraSuperior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports